import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onSuccessUpdateRole } from "./helpers";

export const updateRole = async ({
  id,
  name,
  permissions,
  force,
}: UpdateRoleReqT) =>
  axios.put(urlMaker(Routes.UPDATE_ROLE, id), { name, permissions, force });

export const useUpdateRole = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_ROLE_MUT],
    mutationFn: updateRole,
    onSuccess: onSuccessUpdateRole,
    cacheTime: Infinity,
  });
